import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useRoutes } from 'react-router-dom'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { enUS } from 'date-fns/locale'

import settings from 'settings'
import routes from 'app/Routes'
import useGetAccountData from 'features/account/ui/common/useGetAccountData'
import { initialLaunchDarklyContext } from 'app/ui/useFeatureFlagsFromLd'

function App() {
  const routing = useRoutes(routes)

  const { logout } = useAuth0()

  const accountData = useGetAccountData()

  useEffect(() => {
    if (accountData?.suspended) {
      const accountsUrl = `${settings.accountsUrl}/` // ensure proper root path in self hosted
      logout({ logoutParams: { returnTo: accountsUrl } })
    }
  })

  return (
    // Product & Design Teams decided to use en-US locale by default
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enUS}>
      {routing}
    </LocalizationProvider>
  )
}

// If LaunchDarkly is enabled, wrap App with withLDProvider
const AppWithLD = settings.launchDarklyClientSideId
  ? withLDProvider({
      clientSideID: settings.launchDarklyClientSideId,
      context: initialLaunchDarklyContext,
      reactOptions: {
        useCamelCaseFlagKeys: false
      }
    })(App)
  : App

export default AppWithLD
